module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-bottom-metals-remnants.313bbbb8.png";